export default function isJsonString(str) {
  try {
    return typeof JSON.parse(str) === 'object'
  } catch {
    return false
  }
}
